import getSelectedFolderViewState from './getSelectedFolderViewState';

export default function isBeingEdited(itemId: string): boolean {
    return getSelectedFolderViewState().currentEditingTodoId === itemId;
}
